import React from "react";
//import ReactDOM from 'react-dom/client';
import "./styleHeader.css";

// const NAV_FOOTER = document.getElementById('navFooter');
// Build footer

//build divs
//const NAV_FOOTER_COLUMN1 = document.createElement("Div");
//    NAV_FOOTER_COLUMN1.id = "navFooterColumn1";
//    NAV_FOOTER_COLUMN1.className = "navFooterColumn";
//    NAV_FOOTER_COLUMN1.innerHTML = "© 2023 AfricanMoose"
//    NAV_FOOTER.appendChild(NAV_FOOTER_COLUMN1);

//const NAV_FOOTER_COLUMN2 = document.createElement("Div");
//    NAV_FOOTER_COLUMN2.id = "navFooterColumn2";
//    NAV_FOOTER_COLUMN2.className = "navFooterColumn";
//    NAV_FOOTER_COLUMN2.innerHTML = "Contact us:<br>Tel: + (254) 721 218332";
//    NAV_FOOTER.appendChild(NAV_FOOTER_COLUMN2);

//const NAV_FOOTER_COLUMN3 = document.createElement("Div");
//    NAV_FOOTER_COLUMN3.id = "navFooterColumn3";
//    NAV_FOOTER_COLUMN3.className = "navFooterColumn";
//    NAV_FOOTER_COLUMN3.innerHTML = '<div>Check out our related sites:</div><div><a href="https://Africanmoose.com" target="_blank">Africanmoose Photography</a> <div><div><a href="https://Africanmoose.netlify.com" target="_blank">Africanmoose digital garden</a><div><div><a href="https://Africanmoose.blogspot.com" target="_blank">Africanmoose travel blog</a><div>';
//    NAV_FOOTER.appendChild(NAV_FOOTER_COLUMN3);

function NavFooter() {
    return (
        <div>
           <div className="navFooter" id="navFooter">
                <div id="navFooterColumn1" className="navFooterColumn">© 2026 AfricanMoose</div>
                <div id="navFooterColumn2" className="navFooterColumn">Contact us:
                    <br></br>Tel: + (254) 721 218332</div>
            </div>
       
        </div>
    );
  };
  

  export default NavFooter;
